export const contactsData = {
  email: "alihamzarao6@gmail.com",
  phone: "+923086450918",
  address: "Lahore, Pakistan ",

  sheetAPI: "",
};
